import { Injectable, inject } from '@angular/core';
import { StoreService } from '@state';
import { lastValueFrom } from 'rxjs';
import { FeaturesService } from '@api';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  private readonly storeService = inject(StoreService);
  private readonly featuresService = inject(FeaturesService);
  private readonly tokenService = inject(TokenService);

  public async loadFeatures() {
    if (this.tokenService.isTokenExpired()) {
      return;
    }
    try {
      const features = await lastValueFrom(this.featuresService.getFeatures());
      this.storeService.set('features', features);
    } catch {
      // empty
    }
  }

  public hasFeature(features: string | string[]): boolean {
    const availableFeatures = this.storeService.state$.value.features;
    if (!features) {
      return true;
    }

    if (!availableFeatures) {
      return false;
    }

    if (!Array.isArray(features)) {
      return this.canActivate([features], availableFeatures);
    }

    return this.canActivate(features, availableFeatures);
  }

  private canActivate(features: string[], availableFeatures: Record<string, boolean>): boolean {
    return features.every((feature) => {
      if (feature.startsWith('!')) {
        return !availableFeatures[feature.slice(1)];
      }
      return availableFeatures[feature];
    });
  }
}
